import type { MouseEvent, ReactNode } from 'react';

export interface TabItem {
  key: string;
  label: ReactNode;
  /** 渡すと<a>として描く。URLの組み立てはrouterの責務なので、ここでは受け取るだけ。 */
  href?: string;
}

export interface TabsProps {
  items: TabItem[];
  /** 選択中のTabItem.key。 */
  active: string;
  onSelect: (key: string) => void;
  /** 画面に複数のタブ列が出るため、読み上げ用の名前を付けられるようにする。 */
  label?: string;
}

/**
 * 画面内の表示切替。選択はコールバックで返し、URLの正本はrouter側に置く。
 * hrefを渡した場合もSPA遷移させるが、修飾キー付きクリックと中クリックは
 * 「別タブで開く」というブラウザ本来の操作なので素通しする。
 */
export function Tabs({ items, active, onSelect, label }: TabsProps) {
  return (
    <nav className="tabs" aria-label={label}>
      {items.map((item) => {
        const selected = item.key === active;
        const content = <span>{item.label}</span>;
        if (item.href === undefined) {
          return (
            <button
              key={item.key}
              type="button"
              className="tab"
              aria-current={selected ? 'true' : undefined}
              onClick={() => onSelect(item.key)}
            >
              {content}
            </button>
          );
        }
        return (
          <a
            key={item.key}
            className="tab"
            href={item.href}
            aria-current={selected ? 'true' : undefined}
            onClick={(event: MouseEvent<HTMLAnchorElement>) => {
              if (
                event.defaultPrevented ||
                event.button !== 0 ||
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey
              ) {
                return;
              }
              event.preventDefault();
              onSelect(item.key);
            }}
          >
            {content}
          </a>
        );
      })}
    </nav>
  );
}
